<template>
  <div>
    <section-page
      title="Email Integration"
      description="There are two ways that you can integrate email into Forefront. Which integration would you like to use?"
    >
      <h2 class="email_choice--heading">
        Custom Domain (preferred)
        <app-help-link page-uri="/knowledge-base/forefront-email-set-up/forefront-email-guide/forefront-email-connecting-your-custom-domain-email/">How to set up custom domain</app-help-link>
      </h2>

      <div class="flex flex-between">
        <div class="email_choice--content">
          <p class="email_choice--text">Use your own domain (i.e. JoeBuysHouses.com) to send emails through Forefront. Here is what's different when you choose a custom domain:</p>

          <ul class="email_choice--list">
            <li>It requires technical knowledge</li>
            <li>You'll get email stats such as opened, clicked, etc</li>
            <li>You'll be able to send attachments</li>
            <li>Emails are only stored inside Forefront</li>
            <li>Requires a custom domain and ability to add DNS records</li>
            <li>Requires email client (e.g Gsuite, Outlook, Fastmail)</li>
          </ul>
        </div>

        <button-default
          @click="chooseCustomDomain"
          size=""
          :loading="isDomainLoading"
        >Choose Custom Domain</button-default>
      </div>

      <h2 class="email_choice--heading">
        Gmail Integration
        <app-help-link page-uri="/knowledge-base/forefront-email-set-up/forefront-email-guide/forefront-email-connecting-gsuite-google-workspace-emails/">How to set up gmail integration</app-help-link>
      </h2>

      <div class="flex flex-between mb-100">
        <div class="email_choice--content">
          <p class="email_choice--text">Use Gmail to send emails through Forefront. Here is what's different when you choose Gmail Integration:</p>

          <ul class="email_choice--list">
            <li>All emails stay in your google account and are copied into Forefront</li>
            <li>Requires a Gmail or Google Workspaces account</li>
            <li>No inbound email stats</li>
            <li>No ability to send attachments</li>
          </ul>
        </div>

        <button-default
          @click="chooseGmail"
          size=""
          :loading="isGmailLoading"
        >Choose Gmail</button-default>
      </div>
    </section-page>
  </div>
</template>

<script>
import {ENUMS} from "../../services/enums";

export default {
  name: "EmailSettingsChoiceTab",
  data() {
    return {
      isGmailLoading: false,
      isDomainLoading: false,
    }
  },
  methods: {
    chooseCustomDomain() {
      const form = {
        market_id: this.$store.getters.market.id,
        email_integration_type: ENUMS.EmailIntegrationTypeEnum.MailGun.value
      }

      this.isDomainLoading = true
      this.$api.markets.setEmailIntegration(form)
        .finally(() => { this.isDomainLoading = false })
    },
    chooseGmail() {
      const form = {
        market_id: this.$store.getters.market.id,
        email_integration_type: ENUMS.EmailIntegrationTypeEnum.Gmail.value
      }

      this.isGmailLoading = true
      this.$api.markets.setEmailIntegration(form)
        .finally(() => { this.isGmailLoading = false })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.email_choice {

  &--heading {
    margin: 2rem 0 0.5rem;
    font-size: 1.375rem;
    font-weight: bold;
  }

  &--content {
    max-width: 800px;
  }

  &--text {
    margin-bottom: 0.875rem;
    line-height: 1.4;
  }

  &--list {
    padding-left: 2rem;
    list-style: disc;

    li {
      margin-bottom: 4px;
      line-height: 1.3;
    }
  }
}
</style>
